import React from 'react';
import RenderRootComponent from 'components/render-utils/render-root-component';
import { hot } from 'react-hot-loader';
import PricingDetails from './components/pricing-details';
import './style.scss';
import ErrorBoundary from 'components/error/error-boundary';

export const PriceScheduleApp = () => {
  return(
    <ErrorBoundary>
      <PricingDetails />
    </ErrorBoundary>
  );
}

document.addEventListener("DOMContentLoaded", () => {
  RenderRootComponent(hot(module)(PriceScheduleApp), "price-schedule");
});
